import { useCallback, useState } from 'react';

import { adminLocalizationApi, adminLocalizationKeys } from '@/api';
import { ConstructorApi } from '@/features/constructorProducts/api';
import { queryClient } from '@/app/QueryClientProvider';
import { usePopups } from '@/hooks';

export const useProductSection = ({ productId }) => {
  const { showErrorToast, showSuccessToast } = usePopups();
  const [isCreating, setIsCreating] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleCreate = useCallback(async ({ section }) => {
    try {
      setIsCreating(true);
      const result = await ConstructorApi.createSection(productId, { ...section });
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getProductsSections],
          queryFn: () => adminLocalizationApi.getProductsSections({ productId: productId })
        });
        showSuccessToast('Created');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsCreating(false);
    }
  }, []);

  const handleUpdate = useCallback(async ({ section }) => {
    try {
      setIsUpdating(true);
      const result = await ConstructorApi.updateSection({ ...section });
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getProductsSections],
          queryFn: () => adminLocalizationApi.getProductsSections({ productId: productId })
        });
        showSuccessToast('Saved');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsUpdating(false);
    }
  }, []);

  const handleDelete = useCallback(async (section) => {
    try {
      setIsDeleting(true);
      const result = await ConstructorApi.deleteSection(section);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getProductsSections],
          queryFn: () => adminLocalizationApi.getProductsSections({ productId: productId })
        });
        showSuccessToast('Deleted');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsDeleting(false);
    }
  }, []);

  return {
    handleCreate,
    handleUpdate,
    handleDelete,
    isCreating,
    isUpdating,
    isDeleting
  };
};
